import script from "./detalles.vue?vue&type=script&setup=true&lang=js"
export * from "./detalles.vue?vue&type=script&setup=true&lang=js"

import "./detalles.vue?vue&type=style&index=0&id=31f46100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f46100"]])

export default __exports__